import React from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="text-2xl sm:text-3xl font-heading font-bold tracking-tight mb-4 text-ink-text">
      {title}
    </h2>
    <div className="space-y-4 text-sm sm:text-base text-muted leading-relaxed">
      {children}
    </div>
  </section>
);

export default function Privacy() {
  return (
    <main className="min-h-screen bg-page text-ink-text">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16 sm:py-20">
        <div className="mb-10">
          <Link
            to="/"
            className="mono text-[11px] uppercase tracking-[0.22em] text-brand-cyan hover:text-brand-cyan/80 transition-colors"
          >
            ← На главную
          </Link>
        </div>

        <div className="glass rounded-3xl p-8 sm:p-10 lg:p-12">
          <div className="mb-10">
            <div className="mono text-[10px] uppercase tracking-[0.22em] text-brand-cyan mb-4">
              Privacy
            </div>
            <h1 className="text-4xl sm:text-5xl font-heading font-bold tracking-tight leading-tight mb-4">
              Политика обработки персональных данных
            </h1>
            <p className="text-muted leading-relaxed max-w-3xl">
              Настоящая Политика определяет порядок обработки персональных данных и меры по обеспечению
              безопасности персональных данных, предпринимаемые ООО «ИнБуст» при осуществлении деятельности
              и использовании сайта inboost.pro.
            </p>
          </div>

          <Section title="1. Общие положения">
            <p>
              Оператором персональных данных является ООО «ИнБуст», ИНН 7730334680, ОГРН 1257700054336,
              КПП 771001001, адрес: 127006, г. Москва, вн.тер.г. Муниципальный округ Тверской,
              ул. Садовая-Триумфальная, д.16, стр.3, помещение 2А/1.
            </p>
            <p>
              Адрес электронной почты для обращений по вопросам обработки персональных данных:{" "}
              <a
                href="mailto:inbound@inboost.pro"
                className="text-brand-cyan hover:text-brand-cyan/80 transition-colors"
              >
                inbound@inboost.pro
              </a>
              .
            </p>
            <p>
              Оператор осуществляет обработку персональных данных в соответствии с законодательством
              Российской Федерации, включая Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных»
              и иные применимые нормативные правовые акты.
            </p>
          </Section>

          <Section title="2. Цели обработки персональных данных">
            <p>Оператор может обрабатывать персональные данные в следующих целях:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>рассмотрение входящих обращений, запросов и деловых предложений;</li>
              <li>организация и поддержание коммуникаций с клиентами, партнерами и контрагентами;</li>
              <li>подготовка, заключение и исполнение договоров;</li>
              <li>проведение переговоров, демонстраций продукта и консультаций;</li>
              <li>исполнение обязанностей, установленных законодательством Российской Федерации;</li>
              <li>защита прав и законных интересов Оператора.</li>
            </ul>
          </Section>

          <Section title="3. Категории субъектов и состав данных">
            <p>
              Оператор может обрабатывать персональные данные представителей клиентов, контрагентов,
              партнеров, потенциальных заказчиков и иных лиц, взаимодействующих с Оператором
              в рамках деловых коммуникаций.
            </p>
            <p>В зависимости от характера взаимодействия могут обрабатываться следующие данные:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>фамилия, имя, отчество;</li>
              <li>номер телефона;</li>
              <li>адрес электронной почты;</li>
              <li>должность;</li>
              <li>наименование организации;</li>
              <li>иные сведения, добровольно предоставленные субъектом персональных данных.</li>
            </ul>
            <p>
              Сайт не использует формы сбора персональных данных пользователей. Персональные данные могут
              поступать Оператору через официальные каналы связи, включая электронную почту, телефон,
              мессенджеры, договорную и иную деловую коммуникацию.
            </p>
          </Section>

          <Section title="4. Правовые основания обработки">
            <ul className="list-disc pl-5 space-y-2">
              <li>согласие субъекта персональных данных в случаях, когда такое согласие требуется законом;</li>
              <li>необходимость обработки для заключения и исполнения договора;</li>
              <li>осуществление прав и законных интересов Оператора при соблюдении прав субъекта;</li>
              <li>исполнение обязанностей, возложенных на Оператора законодательством Российской Федерации.</li>
            </ul>
          </Section>

          <Section title="5. Порядок обработки персональных данных">
            <p>
              Обработка персональных данных осуществляется с использованием средств автоматизации и
              без использования таких средств, включая сбор, запись, систематизацию, накопление, хранение,
              уточнение, использование, передачу в предусмотренных законом случаях, блокирование, удаление
              и уничтожение персональных данных.
            </p>
            <p>
              Оператор обрабатывает только те персональные данные, которые необходимы для достижения
              конкретных, заранее определенных и законных целей обработки.
            </p>
            <p>
              Оператор не распространяет персональные данные неопределенному кругу лиц без надлежащих
              правовых оснований.
            </p>
          </Section>

          <Section title="6. Передача персональных данных третьим лицам">
            <p>
              Оператор вправе передавать персональные данные третьим лицам в случаях, предусмотренных
              законодательством Российской Федерации, а также если это необходимо для достижения целей
              обработки, исполнения договора, функционирования ИТ-инфраструктуры, коммуникационных,
              почтовых и хостинговых сервисов при условии соблюдения требований конфиденциальности
              и безопасности персональных данных.
            </p>
          </Section>

          <Section title="7. Сроки обработки и хранения">
            <p>
              Персональные данные обрабатываются и хранятся не дольше, чем этого требуют цели обработки,
              если иной срок не установлен законодательством Российской Федерации, договором
              или согласием субъекта персональных данных.
            </p>
            <p>
              По достижении целей обработки либо при утрате необходимости в их достижении персональные
              данные подлежат удалению или уничтожению, если иное не предусмотрено законом.
            </p>
          </Section>

          <Section title="8. Права субъекта персональных данных">
            <ul className="list-disc pl-5 space-y-2">
              <li>получать сведения, касающиеся обработки его персональных данных;</li>
              <li>требовать уточнения, блокирования или уничтожения персональных данных;</li>
              <li>отозвать согласие на обработку персональных данных в применимых случаях;</li>
              <li>обжаловать действия или бездействие Оператора в уполномоченный орган или в суд;</li>
              <li>осуществлять иные права, предусмотренные законодательством Российской Федерации.</li>
            </ul>
          </Section>

          <Section title="9. Меры по защите персональных данных">
            <p>
              Оператор принимает необходимые и достаточные правовые, организационные и технические меры
              для защиты персональных данных от неправомерного или случайного доступа, уничтожения,
              изменения, блокирования, копирования, предоставления, распространения и иных неправомерных действий.
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>назначение ответственных лиц за организацию обработки персональных данных;</li>
              <li>принятие локальных актов по вопросам обработки и защиты персональных данных;</li>
              <li>ограничение доступа к персональным данным уполномоченными лицами;</li>
              <li>применение мер разграничения доступа к системам и данным;</li>
              <li>внутренний контроль соответствия обработки требованиям законодательства РФ.</li>
            </ul>
          </Section>

          <Section title="10. Трансграничная передача персональных данных">
            <p>
              Оператор не осуществляет трансграничную передачу персональных данных без наличия
              надлежащих правовых оснований и соблюдения требований законодательства Российской Федерации.
            </p>
          </Section>

          <Section title="11. Заключительные положения">
            <p>
              Настоящая Политика является общедоступным документом и размещается в сети Интернет
              по адресу <span className="text-ink-text">https://inboost.pro/privacy</span>.
            </p>
            <p>
              Оператор вправе вносить изменения в настоящую Политику. Актуальная редакция публикуется
              по указанному адресу.
            </p>
            <p>Дата публикации: 19.05.2026</p>
            <p>Дата вступления в силу: 19.05.2026</p>
          </Section>
        </div>
      </div>
    </main>
  );
}